import './ShortcutsPanel.css';

interface ShortcutsPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ShortcutEntry {
  keys: string[];
  description: string;
}

const SHORTCUTS: ShortcutEntry[] = [
  { keys: ['Esc'], description: 'Close all panels' },
  { keys: ['Ctrl', ','], description: 'Open Settings' },
  { keys: ['Ctrl', 'H'], description: 'Open History' },
  { keys: ['Ctrl', 'P'], description: 'Open Projects' },
  { keys: ['?'], description: 'Keyboard Shortcuts' },
  // Ctrl+digit follows SECTION_ORDER in App.tsx.
  { keys: ['Ctrl', '1'], description: 'Project Designer' },
  { keys: ['Ctrl', '2'], description: 'Motor Calculations' },
  { keys: ['Ctrl', '3'], description: 'Transformer Calculator' },
  { keys: ['Ctrl', '4'], description: 'Generator Calculator' },
  { keys: ['Ctrl', '5'], description: 'Wire Ampacity Calculator' },
  { keys: ['Ctrl', '6'], description: 'Feeder/Service Sizing Calculator' },
  { keys: ['Ctrl', '7'], description: 'Conduit Sizing Calculator' },
  { keys: ['Ctrl', '8'], description: 'Voltage Drop Calculator' },
  { keys: ['Ctrl', '9'], description: 'Multi-Motor Feeder Calculator' },
];

export function ShortcutsPanel({ isOpen, onClose }: ShortcutsPanelProps) {
  if (!isOpen) return null;

  return (
    <>
      <div className="shortcuts-overlay" onClick={onClose} />
      <div className="shortcuts-panel">
        <div className="shortcuts-header">
          <h2>Keyboard Shortcuts</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="shortcut-list">
          {SHORTCUTS.map((shortcut, idx) => (
            <div key={idx} className="shortcut-item">
              <span className="shortcut-description">{shortcut.description}</span>
              <span className="shortcut-keys">
                {shortcut.keys.map((key, keyIdx) => (
                  <span key={keyIdx}>
                    {keyIdx > 0 && <span className="shortcut-plus">+</span>}
                    <kbd className="shortcut-key">{key}</kbd>
                  </span>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
